

export class SocialLink {
    static instagram = "https://www.instagram.com/spinanico93/";
    static github = "https://github.com/SpinaNico";
    static youtube = "https://www.youtube.com/channel/UCPNCXSKUGuQ0O1Wa2zfqMQw?view_as=subscriber";
}